import * as State from 'components/desktop/User/User/State';
import { useHandler } from 'hooks/useHandler';

export default function useState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			addApiKey: rf.createReducer(State.addApiKey),
			removeApiKey: rf.createReducerAsync(State.removeApiKey),
			setApiKeys: rf.createReducer(State.setApiKeys),
			setCurrentApiKeyId: rf.createReducer(State.setCurrentApiKeyId),
			generateApiKey: rf.createReducerAsync(State.generateApiKey),
			changeName: rf.createReducer(State.changeName),
			saveApiKey: rf.createReducerAsync(State.saveApiKey),
			addNewApiKey: rf.createReducer(State.addNewApiKey),
			clickCancel: rf.createNoArgReducer(State.clickCancel),
		},
	};
}

export type Handlers = ReturnType<typeof useState>['handlers'];
